import { ExternalLink, MapPin } from "lucide-react";
import type { Message } from "../../types/message";

export default function LocationMessage({ message }: { message: Message }) {
  if (
    !Number.isFinite(message.latitude) ||
    !Number.isFinite(message.longitude)
  ) {
    return <p className="text-sm text-red-600">Localização indisponível.</p>;
  }

  const coordinates = `${message.latitude},${message.longitude}`;
  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(coordinates)}`;
  const embedUrl = `${mapUrl}&z=16&output=embed`;

  return (
    <div className="w-64 max-w-full overflow-hidden rounded-lg bg-white text-slate-800 shadow-sm sm:w-72">
      <iframe
        title={`Mapa de ${message.locationName ?? "localização"}`}
        src={embedUrl}
        className="h-36 w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="space-y-1 p-3">
        <div className="flex items-start gap-2">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
          <div className="min-w-0">
            <p className="font-medium leading-tight">
              {message.locationName ?? "Localização"}
            </p>
            {message.address && (
              <p className="mt-1 text-xs leading-relaxed text-slate-500">
                {message.address}
              </p>
            )}
          </div>
        </div>
        <a
          href={mapUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-xs font-medium text-emerald-700 hover:underline"
        >
          Abrir no Google Maps <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
